<div class="image-viewer-container">
    <div class="image-viewer">
        <div (click)="dialogRef.close()" class="close" matTooltipPosition="after">
            <i class="fa fa-times"></i>
        </div>
        <swiper-container #swiperRef (wheel)="onScroll($event)" [slidesPerView]="1" loop="true" mousewheel="false" navigation="true" zoom="true">
            @for (img of data.images; track img) {
                <swiper-slide>
                    <div class="swiper-zoom-container image">
                        @if (img.path) {
                            <img [src]="(Settings.API_ENDPOINT+'file/thumb?'+secure()+'path=/'+img.article_id+'/'+img.path+'&access_token='+LocalStorage.getUserToken())">
                        } @else {
                            <img [src]="img">
                        }
                    </div>
                </swiper-slide>
            }
        </swiper-container>
    </div>
</div>
